import Head from "next/head"
import { useRouter } from "next/router"
import { useContext, useEffect } from "react"

import Loader from "../components/Loader"
import UserOnly from "../components/UserOnly"
import { useGetCommunitiesQuery } from "../generated/graphql"
import { UserContext } from "./UserProvider"

const Home = () => {
  const { accessToken, communities } = useContext(UserContext)
  const { data } = useGetCommunitiesQuery({
    context: {
      session: {
        accessToken,
      },
    },
    skip: !accessToken,
  })
  const router = useRouter()

  useEffect(() => {
    let communityId = communities[0]?.id
    if (!communityId) {
      communityId = data?.user?.communitiesWhereAdmin[0].id || ""
    }
    if (accessToken && communityId) {
      void router.push(`/${communityId}/analytics`)
    }
  }, [data])

  return (
    <UserOnly>
      <Head>
        <meta content="width=device-width, initial-scale=1, maximum-scale=1" name="viewport" />
        <title>Home</title>
      </Head>
      <main className="flex justify-center items-center h-screen">
        <div className="flex flex-1 justify-center items-center h-full">
          <Loader />
        </div>
      </main>
    </UserOnly>
  )
}

export default Home
